var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 13.3367V14.1667C3.33325 14.8297 3.59664 15.4656 4.06549 15.9344C4.53433 16.4033 5.17021 16.6667 5.83325 16.6667H14.1666C14.8296 16.6667 15.4655 16.4033 15.9344 15.9344C16.4032 15.4656 16.6666 14.8297 16.6666 14.1667V13.3333M9.99992 3.75V12.9167M9.99992 12.9167L12.9166 10M9.99992 12.9167L7.08325 10",
    stroke: "#5070DE",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.fd0b6814347cb49a894af42c14501398.svg";
export { ForwardRef as ReactComponent };